/*
* Story Theme
*
* Use this file to add custom Javascript to Story.  Keeping your custom
* Javascript in this fill will make it easier to update Story. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {
  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.





  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();


// Floating ATC button
function floatingATC() {
  let a = document.querySelector('.product__form__outer');
  let b = document.querySelector('.WI_stickyAtc_btn');
  let f = document.querySelector('.footer');
  function handelIntersection(e, o) {
      e.forEach(en => {
          if (en.isIntersecting) {
              b.style.transform = 'translateY(70px)';
          }else{
              b.style.transform = 'translateY(0)';
          }
      });
  };
  let o = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
  }

  let floatingObserver = new IntersectionObserver(handelIntersection,o);
  floatingObserver.observe(a);
  floatingObserver.observe(f);
//^^ Floating button on click
  b.addEventListener('click', ()=>{
      a.scrollIntoView({ behavior: "smooth", block: 'center' });
  });
};
floatingATC();

let atcBtnTxt = document.querySelector('.product__submit__add').innerHTML;
let atcFloatingBtn = document.querySelector('.WI_stickyAtc_btn');
if (atcBtnTxt != null) {
  atcFloatingBtn.innerHTML = atcBtnTxt;
}